// 每一頁進入時的 polyfill 改用 `core-js/stable` `regenerator-runtime` 取代 @babel/polyfill
// https://babeljs.io/docs/en/babel-polyfill
// `(window|global).core` 是 core-js 的 global bariable
if (typeof core === 'undefined') {
  require('core-js/stable')
  require('regenerator-runtime')
  require('intersection-observer')
}
